<template>
  <div v-if="items.length" :id="screen.chave" :data-screen-id="screen.id" :class="gridClass">
    <template v-if="['directory', 'capabilities'].includes(kind)">
      <ul :class="kind === 'directory' ? 'directory' : 'capability-list'">
        <li v-for="item in items" :key="itemId(item)" :data-record-id="itemId(item)">
          <ContentLink v-if="kind === 'directory' && link(item)" :to="link(item)" class="text-link"
            >{{ text(item, 'iti_nome') }}<ArrowIcon
          /></ContentLink>
          <h3 v-else-if="kind === 'directory'">{{ text(item, 'iti_nome') }}</h3>
          <template v-else>{{ text(item, 'iti_nome') }}</template>
          <RichText
            v-if="has('iti_descricao1')"
            :value="value(item, 'iti_descricao1')"
            class="prose"
            data-campo="itiDescricao1"
          />
        </li>
      </ul>
    </template>
    <ol v-else-if="kind === 'steps'" class="steps">
      <li v-for="item in items" :key="itemId(item)" :data-record-id="itemId(item)">
        <h3>{{ text(item, 'iti_nome') }}</h3>
        <RichText :value="value(item, 'iti_descricao1')" data-campo="itiDescricao1" />
      </li>
    </ol>
    <template v-else-if="kind === 'faq'">
      <details v-for="item in items" :key="itemId(item)" :data-record-id="itemId(item)">
        <summary>{{ text(item, 'iti_nome') }}</summary>
        <RichText :value="value(item, 'iti_resumo1')" />
      </details>
    </template>
    <template v-else>
      <article
        v-for="item in items"
        :key="itemId(item)"
        :data-record-id="itemId(item)"
        :class="cardClass"
        :id="screen.id === 48 ? slug(text(item, 'iti_nome')) : undefined"
      >
        <ContentLink v-if="detailType && hasPhoto(item)" :to="link(item)" class="card-image-link"
          ><RecordImage
            :item="item"
            :screen="screen"
            :class="kind === 'news' ? 'news-image' : 'card-image'"
        /></ContentLink>
        <div :class="{ 'card-body': kind === 'services' }">
          <p v-if="kind === 'news' && text(item, 'iti_campoextra1')" class="eyebrow">
            {{ text(item, 'iti_campoextra1') }}
          </p>
          <p v-if="kind === 'information' && text(item, 'iti_referencia')" class="eyebrow">
            {{ text(item, 'iti_referencia') }}
          </p>
          <h3>
            <ContentLink v-if="detailType" :to="link(item)">{{
              text(item, 'iti_nome')
            }}</ContentLink
            ><ContentLink
              v-else-if="screen.id === 48 && slug(text(item, 'iti_nome')) === 'empresas-familiares'"
              to="/empresas-familiares"
              >{{ text(item, 'iti_nome') }}</ContentLink
            ><template v-else>{{ text(item, 'iti_nome') }}</template>
          </h3>
          <RichText
            v-if="detailType"
            :value="value(item, 'iti_resumo1')"
            class="card-summary"
            data-field="iti_resumo1"
          />
          <template v-else>
            <RichText
              v-if="has('iti_descricao1')"
              :value="value(item, 'iti_descricao1')"
              class="prose"
              data-campo="itiDescricao1"
              data-field="iti_descricao1"
            />
            <p v-if="has('iti_referencia') && !contact">{{ text(item, 'iti_referencia') }}</p>
            <ContactDetails v-if="contact" :item="item" />
            <RichText v-if="contact" :value="value(item, 'iti_resumo1')" class="prose" />
            <RecordButtons :item="item" :screen="screen" />
          </template>
          <ContentLink v-if="detailType" :to="link(item)" class="text-link"
            >{{ kind === 'services' ? 'Conheça a solução' : 'Leia mais' }}<ArrowIcon
          /></ContentLink>
        </div>
      </article>
    </template>
  </div>
</template>
<script>
import ContentLink from './ContentLink.vue';
import RichText from './RichText.vue';
import RecordImage from './RecordImage.vue';
import RecordButtons from './RecordButtons.vue';
import ArrowIcon from './ArrowIcon.vue';
import ContactDetails from './ContactDetails.vue';
import {
  contentValue,
  plainText,
  itemId,
  detailPath,
  safeLink,
  firstImage,
  slug,
} from '@/services/contentApi';
export default {
  name: 'ApprovedList',
  components: { ContentLink, RichText, RecordImage, RecordButtons, ArrowIcon, ContactDetails },
  props: {
    items: { type: Array, default: () => [] },
    screen: Object,
    kind: { type: String, default: 'cards' },
    contact: Boolean,
  },
  computed: {
    detailType() {
      return { services: 'solucoes', news: 'insights', information: 'informacoes' }[this.kind];
    },
    gridClass() {
      return (
        {
          services: 'service-grid',
          news: 'news-grid',
          brands: 'brand-grid',
          cards: 'info-grid',
          information: 'info-grid',
          text: 'text-list',
          faq: 'faq-list',
        }[this.kind] || ''
      );
    },
    cardClass() {
      return (
        {
          services: 'service-card',
          news: 'news-card',
          cards: 'info-card',
          information: 'info-card',
          text: 'text-block',
        }[this.kind] || ''
      );
    },
  },
  methods: {
    slug,
    itemId,
    value: contentValue,
    text(item, field) {
      return plainText(contentValue(item, field));
    },
    has(field) {
      return this.screen.campos.some((f) => f.campo === field);
    },
    hasPhoto(item) {
      return Boolean(firstImage(item, this.screen));
    },
    link(item) {
      return this.detailType
        ? detailPath(this.detailType, item)
        : safeLink(contentValue(item, 'iti_linkbtn1'));
    },
  },
};
</script>
